import { render, staticRenderFns } from "./IntegralRule.vue?vue&type=template&id=89cc2038&scoped=true&"
import script from "./IntegralRule.vue?vue&type=script&lang=js&"
export * from "./IntegralRule.vue?vue&type=script&lang=js&"
import style0 from "./IntegralRule.vue?vue&type=style&index=0&id=89cc2038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cc2038",
  null
  
)

export default component.exports